import {EnvironmentType} from '../../../shared/model/EnvironmentType.model';
import {Environment, EnvironmentAttributes} from './Environment.model';

export const findEnvironmentByType = <T extends EnvironmentAttributes>
(envType: EnvironmentType, environments: Array<Environment<T>>): Environment<T> | undefined =>
  environments?.find(env => env.type === envType);